/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from "react";
import {connect} from "react-redux";
import {Glyphicons, Icon} from "../../atoms/bootstrap/Icons";
import {initializeOrderBeforeMsg} from "../../../actions/orderBeforeMsg";
import {compose} from "redux";
import {withI18N} from "../../hoc/withI18N";
import {getMoment} from "../../../utils/momentUtils";
import {isEcomEnabled, isMyPuratosEnabled} from "../../../selectors/generic";
import {ShowHide} from "../../atoms/layout/ShowHide";

const moment = getMoment();

function _OrderBeforeMessage({ message, translate, initializeOrderBeforeMsg, enabled }){
    React.useEffect(() => {
        if (enabled) {
            initializeOrderBeforeMsg();
        }
    }, [ enabled ]);

    return (
        <ShowHide show={enabled}>
            {message &&
                <div className="alert alert-warning alert-sm p-margin-top">
                    <Icon type={Glyphicons.time} className="p-margin-right-sm"/>
                    {translate("Please order before {1} to receive your order on {2}")
                        .replace("{1}", moment(message.data.orderBeforeTime, "HH:mm:ss").format("LT"))
                        .replace("{2}", moment(message.data.deliveryDate, "YYYY-MM-DD").format("dddd"))}
                </div>
            }
        </ShowHide>
    );
}

const mapStateToProps = (state) => ({
    message: state.orderBeforeMsg.data,
    enabled: isEcomEnabled(state) && isMyPuratosEnabled(state)
});

const mapActionToProps = {
    initializeOrderBeforeMsg
};

export const OrderBeforeMessage = compose(withI18N, connect(mapStateToProps, mapActionToProps))(_OrderBeforeMessage);
